import { formatDistanceToNow } from 'date-fns';
import { Notification } from '../../hooks/notifications/useNotifications';
import { Button } from '../../components/Button';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

interface NotificationItemProps {
  notification: Notification;
  tripUrl: string | undefined;
  onClick: () => void;
}

/**
 * Individual notification item component.
 * Displays notification message, unread indicator, and time.
 */
export function NotificationItem({ notification, tripUrl, onClick }: NotificationItemProps) {
  const timeAgo = formatDistanceToNow(new Date(notification.creation), { addSuffix: true });

  return (
    <Button
      variant="ghost"
      onClick={onClick}
      disabled={!tripUrl}
      className="w-full text-left px-4 py-4 rounded-none"
    >
      <div className="flex items-start gap-3">
        {!notification.read && (
          <span className="mt-1.5 h-2.5 w-2.5 flex-shrink-0 rounded-full bg-action-primary" />
        )}
        <div className={classNames('flex-1 min-w-0', notification.read ? 'ml-5' : '')}>
          <p className="text-sm text-main">{notification.message}</p>
          <p className="text-xs text-muted mt-1">{timeAgo}</p>
        </div>
      </div>
    </Button>
  );
}
